// extracted by mini-css-extract-plugin
export default {"successContainer":"SuccessModal_successContainer__0YWVz","title":"SuccessModal_title__LOLub","buttons":"SuccessModal_buttons__L3AHK"};